<template>
  <common-template>
      <div class="list">
        <h1 id="board-title" class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>
        <div id="board-select" class="inner d-flex justify-content-end mt-4 mb-4">
          <div class="form-group d-flex justify-content-end align-items-center mb-0 w-50">
            <select v-model="processKindId" class="form-control mr-2 w-25">
              <option value="">-</option>
              <optgroup v-for="(item, index) in processKinds" :key="`parent-${index}`" :label="$t(item.messageKey)">
                <option v-for="(kind) in item.datas" :key="kind.id" :value="kind.id">&nbsp;&nbsp;{{ $t(kind.messageKey) }}</option>
              </optgroup>
            </select>
            <select v-model="partnerId" class="form-control w-25">
              <option value="">-</option>
              <template v-for="(item) in master.partners">
                <option v-if="item.isSupplier" :key="item.id" :value="item.id">{{ item.name }}</option>
              </template>
            </select>
          </div>
        </div>
        <div class="board inner">
          <div id="board-head-wrap">
            <div class="d-flex border-left border overflow-hidden" id="board-head">
              <div class="w-30 border-right board-head-left">
                <div class="d-flex align-items-end h-100">
                  <button type="button" class="btn btn-success ml-3 mb-3" @click="partnerModalOpen()">
                    {{ $t("外注先登録") }}
                  </button>
                </div>
              </div>
              <div class="w-70 board-head-right">
                <table class="table m-0">
                  <thead class="thead">
                    <tr>
                      <th v-for="(item, index) in monthlySchedule" :key="`mouth-${index}`" :style="`width: ${item.days.length * 60}px;`" :colspan="item.days.length" class="text-left border-top-0 border-bottom-0 border-right">{{ item.month }}</th>
                    </tr>
                    <tr>
                      <template v-for="(item,index) in monthlySchedule">
                        <template v-for="(day, num) in item.days">
                          <td :key="`day-${index}-${num}`" :class="{'wf-60':true,' border-right':true,'board-calendar-holiday': day.isHoliday}">
                            {{ day.format }}
                          </td>
                        </template>
                      </template>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>
          <div class="d-flex border-left border border-top-0 overflow-auto" id="board-body">
            <div class="w-30">
              <table id="board-body-left-table" class="table mb-0">
                <tbody class="tbody overflow-auto">
                  <template v-for="(item, index) in changePartner">
                    <tr :key="`partner-${index}`" :class="{'white-space-nowrap': true,'overflow-hidden':true,'board-body-even': mixinEvenOrOdd(index),'board-body-odd': !mixinEvenOrOdd(index),}">
                      <td class="text-left border-right border-top-0 border-bottom align-top w-55 hf-38" :rowspan="item.processKindIds.length === 0 ? 1 : item.processKindIds.length">
                        <div class="text-nowrap float-left w-60 m-0 overflow-hidden">{{ item.name }}</div>
                        <div class="w-40 float-right overflow-hidden">
                          <button
                          @click="partnerModalOpen(item)"
                          class="btn btn-light btn-board mr-1">
                            <font-awesome-icon :icon="['far','edit']" />
                          </button>
                          <button :class="{btn:true, 'btn-light': true, 'btn-board':true, 'mr-1':true,invisible: index === 0}" @click="updatePartnerSortUp(index);">
                            <font-awesome-icon :icon="['fas','arrow-up']" />
                          </button>
                          <button :class="{btn:true, 'btn-light': true, 'btn-board':true,invisible: changePartner.length === index + 1}" @click="updatePartnerSortDown(index);">
                            <font-awesome-icon :icon="['fas','arrow-down']" />
                          </button>
                        </div>
                      </td>
                      <td v-if="item.processKindIds.length" class="text-left border-top-0 border-bottom border-right hf-38">
                        <div class="text-nowrap float-left w-100 overflow-hidden">{{ $t(mixinProcessKindDisplay(Number(item.processKindIds[0]))) }}</div>
                        <!-- <div class="w-35 float-right overflow-hidden">
                          <button class="btn btn-light btn-board">
                            <font-awesome-icon :icon="['far','edit']" />
                          </button>
                        </div> -->
                      </td>
                      <td v-else class="border-top-0 border-bottom border-right"></td>
                    </tr>
                    <template v-if="item.processKindIds.length > 1">
                      <template v-for="(kindId, num) in item.processKindIds">
                        <tr v-if="num !== 0" :key="`kindId-${index}-${num}`" :class="{'white-space-nowrap': true,'overflow-hidden':true,'board-body-even': mixinEvenOrOdd(index),'board-body-odd': !mixinEvenOrOdd(index),}">
                          <td class="text-left border-top-0 border-bottom border-right hf-38">
                            <div class="text-nowrap float-left w-100 overflow-hidden">{{ $t(mixinProcessKindDisplay(Number(kindId))) }}</div>
                            <!-- <div class="w-35 float-right overflow-hidden">
                              <button class="btn btn-light btn-board">
                                <font-awesome-icon :icon="['far','edit']" />
                              </button>
                            </div> -->
                          </td>
                        </tr>
                      </template>
                    </template>
                    <!-- <tr :key="`btn-${index}`" :class="{'overflow-hidden':true,'board-body-even': mixinEvenOrOdd(index),'board-body-odd': !mixinEvenOrOdd(index),}">
                      <td class="text-left border-right border-top-0 border-bottom overflow-hidden hf-38">
                        <button type="button" class="text-nowrap btn btn-success btn-board overflow-hidden" @click="createModalOpen()">
                          {{ $t("担当者登録") }}
                        </button>
                      </td>
                      <td class="text-left border-top-0 border-bottom border-right overflow-hidden hf-38">
                        <button type="button" class="text-nowrap btn btn-light btn-board overflow-hidden" @click="createModalOpen()">
                          {{ $t("担当者選択") }}
                        </button>
                      </td>
                    </tr> -->
                  </template>
                </tbody>
              </table>
            </div>
            <div class="w-70 board-body-right align-items-stretch">
              <div class="board-body-right__inner" id="board-body-right__inner"></div>
            </div>
          </div>
        </div>
      </div>
    <div class="footer-bg" id="board-footer"></div>
    <partner-modal
    ref="partner"
    :kinds="processKinds"
    :outsourcing="true"
    @registed="init()"
    @modal-close="init()"
    ></partner-modal>
  </common-template>
</template>

<script>
import partnerModal from '../partner/partnerModal.vue'

import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      list: [],
      master: {},
      processKinds: [],
      users: [],
      partners: [],
      load: false,
      partnerId: null,
      processKindId: null,
      pageTitle: '外注ボード',
    }
  },
  components: {
    // createModal,
    // assignedModal,
    // passwordResetModal,
    partnerModal,
  },
  async created() {
    // this.load = true
    try {
      await this.$store.dispatch('auth/user')
    } catch (err) {
      this.$toasted.show(this.$t('データ取得エラーメッセージ'))
    }
    this.init()
  },
  mounted() {
    // window.addEventListener('scroll',() => {
    //   scrollAddClass()
    // })
    this.adjustmentHeight()
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  methods: {
    async getPartnersData() {
      try {
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/partners`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.partners = res.data
        this.partners.sort((a, b) => {
          return a.sort > b.sort ? 1 : -1
        })
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    async getMasterData() {
      try {
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/masters`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.master = res.data
        this.users = this.master.users
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    async getProcessKindData() {
      try {
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/process/kinds`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
        })
        this.processKinds = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    // 値を初期化
    async init() {
      await this.getPartnersData()
      await this.getProcessKindData()
      await this.getMasterData()
    },
    // async search() {
    //   this.load = true
    //   // let params = {}
    //   // if(this.form.site) params.site = this.form.site
    //   // if(this.form.dep) params.dep = this.form.dep
    //   try {
    //     this.list = []
    //     const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/imports`,{
    //       headers: {
    //         'Authorization': this.authorization ? this.authorization : null,
    //       },
    //     })
    //     this.list = res.data
    //   } catch(err) {
    //     this.$toasted.show(this.$t('データ取得エラーメッセージ'))
    //   }
    //   this.load = false
    // },
    // ウィンドウの高さからスクロールがある部分の項目の高さを調整と背景の高さを調整
    updatePartnerSortUp(i) {
      const partner = this.changePartner
      partner.splice(i - 1, 2, partner[i], partner[i - 1])
      let targets = []
      let index = 0
      partner.forEach(item => {
        index++
        targets.push({id: item.id, sort: index})
      })
      this.updatePartnerSort(targets)
    },
    updatePartnerSortDown(i) {
      const partner = this.changePartner
      partner.splice(i, 2, partner[i + 1], partner[i])
      let targets = []
      let index = 0
      partner.forEach(item => {
        index++
        targets.push({id: item.id, sort: index})
      })
      this.updatePartnerSort(targets)
    },
    async updatePartnerSort(targets) {
      try {
        await this.$axios.put(
          `${this.$appConfig.CommonApiUrl}/partners`,
          {
            'targets': targets,
          },
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        await this.getPartnersData()
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
      } catch (err) {
        console.log(err)
        await this.getPartnersData()
        this.$toasted.show(this.$t('データ削除エラーメッセージ'))
      }
    },
    adjustmentHeight(partners = []) {
      const boardBodyRightInner = document.getElementById('board-body-right__inner')
      const boardBody = document.getElementById('board-body')
      const titleHeight = $('#board-title').outerHeight(true)
      const selectHeight = $('#board-select').outerHeight(true)
      const boardHeadHeight = $('#board-head').outerHeight(true)
      const footerHeight = $('#board-footer').outerHeight(true)
      const marginBottom = 0
      const totalHeght = titleHeight + selectHeight + boardHeadHeight + footerHeight + marginBottom
      const windowHeight = window.innerHeight
      let count = 0
      if (partners.length === 0) {
        boardBody.style.height = '38px'
        boardBodyRightInner.style.height = '38px'
        return
      }
      partners.map(item => {
        if (item.processKindIds.length === 0) return count++
        if (item.processKindIds.length) return count += item.processKindIds.length
      })
      const rightHeight = count * 38
      boardBodyRightInner.style.height = `${rightHeight}px`
      if ((windowHeight - totalHeght) > rightHeight) {
        boardBody.style.height = rightHeight + 'px'
      } else if ((windowHeight - totalHeght) < 400) {
        boardBody.style.height = '40rem'
        boardBody.style.margin = '0 0 8rem 0'
      } else {
        boardBody.style.height = (windowHeight - totalHeght) + 'px'
      }
    },
    // 外注登録モーダルを開く処理
    partnerModalOpen(item = null) {
      this.$refs.partner.modalOpen(item)
    },
  },
  computed: {
    changePartner() {
      if (Object.keys(this.master).length === 0) return []
      if (this.partners.length === 0) return []
      let result = []
      if (!this.processKindId && !this.partnerId) {
        result = this.partners.filter(item => item.isSupplier)
      } else if (this.processKindId && !this.partnerId) {
        result = this.mixin_deepcopy(this.partners.filter(item => item.isSupplier && item.processKindIds.includes(String(this.processKindId))))
      } else if (!this.processKindId && this.partnerId) {
        result = this.partners.filter(item => item.isSupplier && item.id === this.partnerId)
      } else if (this.processKindId && this.partnerId) {
        result = this.mixin_deepcopy(this.partners.filter(item => item.isSupplier && item.processKindIds.includes(String(this.processKindId)) && item.id === this.partnerId))
      }
      if (this.processKindId) {
        result.map(item => {
          item.processKindIds = item.processKindIds.filter(id => id == this.processKindId)
        })
        // return result
      }
      // sort順に並び替える
      // result.sort((a,b) => {
      //   return a.sort > b.sort ? 1: -1
      // })
      return result
    },
    ...mapGetters({
      authorization: 'auth/authorization',
      monthlySchedule: 'date/monthlySchedule',
    }),
  },
  watch: {
    'changePartner': {
      handler: function(newVal) {
        this.adjustmentHeight(newVal)
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.board {
  position: relative;
}
.board-thead {
  height: 7.4rem;
}
.btn-board {
  font-size: 1rem !important;
  height: auto !important;
  padding: .2rem .5rem;
}
.board-calendar-holiday {
  background-color: rgba(255, 219, 219, 0.4);
}
.board-body-even {
  background-color: #fffdf4;
}
.board-body-odd {
  background-color: #f2f5ff;
}
.board-body-right {
  display: flex;
  position: relative;
  z-index: 0;
}
.board-body-left {
  position: relative;
  z-index: 1;
}
#board-body-left-table {
  table-layout: fixed;
}
.board-body-right__inner {
  width: 100%;
  align-items: stretch;
  background: repeating-linear-gradient(-45deg, #f5f5f5, #f5f5f5 7px, #ddd 0, #ddd 14px);
  border-top: none !important;
  border-right: none !important;
  box-sizing: border-box;
}
// #board-head {
//   position: absolute;
//   width: 100%;
//   top: 0;
// }
// #board-head-wrap.fix {
//   position: fixed;
//   margin: 0 auto;
//   background-color: #fff;
//   z-index: 100;
//   top: 53px;
//   left: 50%;
//   transform: translateX(-50%);
// }
// #board-head.fix {
//   margin: 0 15px;
// }
// #board-body {
//   padding-top: 7.7rem;
// }
</style>
